import { SessionActionTypes, SessionState, CREATE_SESSION_SUCCESS, DELETE_SESSION_SUCCESS, CREATE_SESSION_FAILURE } from "store/reducers/types/session";

const defaultState: SessionState = {
  isLoading: false,
  isAuthenticated: false,
  errorMessage: "",
  userName: '',
  userId: -1
};

export default function session(state = defaultState, action: SessionActionTypes): SessionState {
  switch (action.type) {
    case CREATE_SESSION_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        ...(action.contents && {
          userName: action.contents.user.userName,
          userId: action.contents.user.userID,
        }),
        errorMessage: "",
      };
    case DELETE_SESSION_SUCCESS:
    case CREATE_SESSION_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        errorMessage: action.message,
      };
    default:
      return state;
  }
}
